
import a1residential from './assets/a1residential.png'
import prontocasecase from "./assets/pronto.png"
import waa from "./assets/waa.png"
import crm from "./assets/crm.png"
import PathFinder from "./assets/geo-location.png"
import Profile_Photo from "./assets/Raju_Profile_photo.gif"
import heroBg from "./assets/webdev.svg";
import cloud from "./assets/cloudBg.png";
import cloudDark from "./assets/cloudDark.png";
import iKidz from "./assets/ikidz.png";
import relaxNow from "./assets/relax-now.png"
import  pisteyo from "./assets/pisteyo.jpeg"
import monday from "./assets/monday.jpeg"
import ga from "./assets/ga.jpg"
import lovelife from "./assets/lovelife.jpg"
import sportsjournal from "./assets/sportsjournal.jpeg"
import TrendingNow from "./assets/TrendingNow.jpg"
import talktoenergy from "./assets/talktoenergy.jpeg"
import highcourt from "./assets/highcourt.jpeg"
import hcba from "./assets/hcba.jpeg"
import skin_care from "./assets/skin-care-app.jpeg"
import swing from "./assets/swing-user.png"
import swingAdmin from "./assets/swing-admin.png"
import GaAdmin from "./assets/ga-admin.jpeg"
import WhatKeyAdmin from "./assets/what-key-admin.jpeg"

import {calculateAgeInYears} from './utills/calculateAgeInYears'

const shortIntro = `I am a Front-End / Full-Stack Developer. I am currently working at
                           Anix Inventive Private Limited as a Full-Stack Developer.`
const techStack = [
  {
    name: "Javascript",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg",
    source:"https://developer.mozilla.org/en-US/docs/Web/JavaScript",
  },
  
  {
    name: "TypeScript",
    link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/typescript/typescript-original.svg",
    source:"https://www.typescriptlang.org/docs/",
  },
  {
    name: "React JS",
    link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original-wordmark.svg",
    source:"https://legacy.reactjs.org/docs/getting-started.html",

  },
  {
    name: "Angular JS",
    link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/angularjs/angularjs-original.svg",
    source:"https://angular.dev/overview",

  },  
  {
    name: "Next Js",
    link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/nextjs/nextjs-original-wordmark.svg",
    source:"https://nextjs.org/docs",
  },
  {
    name: "Inertia Js",
    link: "https://avatars.githubusercontent.com/u/47703742?s=100&v=4",
    source:"https://inertiajs.com/"
  },
  {
    name: "Redux",
    link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/redux/redux-original.svg",
    source:"https://handsonreact.com/docs/redux-thunk"
  },
  {
    name: "Bootstrap",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-plain.svg",
    source:"https://getbootstrap.com/docs/4.1/getting-started/introduction/"
  },
  {
    name: "Sass",
    link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/sass/sass-original.svg",
    source:"https://sass-lang.com/documentation/"
  }, 
  {
    name: "Tailwind CSS",
    link: "https://www.vectorlogo.zone/logos/tailwindcss/tailwindcss-icon.svg",
    source:"https://tailwindcss.com/docs/installation/framework-guides"
  },
  {
    name: "Material Ui",
    link: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS5nXwOB0nj3JI6mxepmQT1QC7hucMd9Fx1ig&s",
    source:"https://mui.com/material-ui/"
  },
  {
    name: "NodeJS",
    link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/nodejs/nodejs-original-wordmark.svg",
    source:"https://www.w3schools.com/nodejs/default.asp"
  },
  {
    name: "Express Js",
    link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/express/express-original-wordmark.svg",
    source:"https://devdocs.io/express/"
  },
  {
    name: "NestJS",
    link: "https://docs.nestjs.com/assets/logo-small-gradient.svg",
    source: "https://docs.nestjs.com/"
  },
  {
    name: "Mongo DB",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-plain.svg",
    source:"https://www.mongodb.com/docs/atlas/getting-started/"
  },
  {
    name: "MySQl",
    link: "https://w7.pngwing.com/pngs/962/92/png-transparent-database-mysql-backup-linux-command-line-interface-database-symbol-blue-commandline-interface-electric-blue-thumbnail.png",
    source:"https://dev.mysql.com/doc/"
  },
  {
    name: "Postman",
    link: "https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg",
    source:"https://learning.postman.com/docs/introduction/overview/"
  },
  {
    name: "Dart",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/dart/dart-original.svg",
    source:"https://dart.dev/language"
  },
  {
    name: "Flutter",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flutter/flutter-plain.svg",
    source:"https://docs.flutter.dev/get-started/learn-flutter"
  },
  {
    name: "React Native",
    link: "https://pagepro.co/blog/wp-content/uploads/2020/03/react-native-logo-884x1024.png",
    source:"https://reactnative.dev/docs/getting-started"
  },
  {
    name: "HTML",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg",
    source:"https://developer.mozilla.org/en-US/docs/Web/HTML"
  },
  {
    name: "CSS",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-plain.svg",
    source:"https://developer.mozilla.org/en-US/docs/Web/CSS"
  },
  {
    name: "Heroku",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/heroku/heroku-plain.svg",
    source:"https://devcenter.heroku.com/articles/getting-started-with-nodejs"
  },
  {
    name: "Git",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-plain.svg",
    source:"https://git-scm.com/docs"
  },
  // {
  //   name: "C Language",
  //   link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/c/c-plain.svg",
  // },
  {
    name: "C++",
    link: "https://w7.pngwing.com/pngs/579/803/png-transparent-the-c-programming-language-programmer-computer-programming-programming-blue-logo-computer-program-thumbnail.png",
    source:"https://www.w3schools.com/cpp/"
  },
  // { name: "Azure", link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/azure/azure-plain.svg" },
  // { name: "Docker", link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-plain.svg" },
  {
    name: "Firebase",
    link: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
    source:"https://firebase.google.com/docs"
  },
];

const contactLinks = [
  {
    name: "LinkedIn",
    url: "https://img.icons8.com/doodle/40/000000/linkedin--v2.png",
    link: "https://www.linkedin.com/in/29159rajusingh/",
  },
  {
    name: "Github",
    url: "https://img.icons8.com/doodle/40/000000/github--v1.png",
    link: "https://github.com/rajusingh99",
  },
  {
    name: "Leetcode",
    url: "https://img.icons8.com/external-tal-revivo-color-tal-revivo/24/external-level-up-your-coding-skills-and-quickly-land-a-job-logo-color-tal-revivo.png",
    link: "https://leetcode.com/u/RajusinghofficialIND/",
  },
  {
    name: "Stack Overflow",
    url: "https://img.icons8.com/external-tal-revivo-color-tal-revivo/40/000000/external-stack-overflow-is-a-question-and-answer-site-for-professional-logo-color-tal-revivo.png",
    link: "https://stackoverflow.com/users/19923888/raju-kumar",
  },
  {
    name: "Instagram",
    url: "https://img.icons8.com/doodle/40/000000/instagram-new--v2.png",
    link: "https://www.instagram.com/rajusinghstm/",
  },
  {
    name: "Youtube",
    url: "https://img.icons8.com/?size=50&id=85162&format=png&color=000000",
    link: "https://www.youtube.com/@Coverage_Blogs",
  },
  {
    name: "X",
    url: "https://img.icons8.com/?size=50&id=13963&format=png&color=000000",
    link: "https://x.com/RajuSingh_159",
  },
];

 const serviceData = [
  {
    name: "Front-End Development",
    desc: "Web design encompasses many different skills and disciplines in the production and maintenance of websites. I focused on web design, User interface design, Responsive Development, Standards-Compliant Code, User Experience (UX) Design, and SEO-Friendly Development. This approach enhances your brand by delivering a seamless and engaging user experience.",
    img: "https://img.icons8.com/external-kiranshastry-lineal-color-kiranshastry/64/000000/external-web-development-coding-kiranshastry-lineal-color-kiranshastry.png",
  },
  {
    name: "Back End Development",
    desc: `Back End development is the backbone of any robust
           and scalable web application. My expertise lies in building and 
           maintaining the server-side logic, database management, and API 
           integrations that power dynamic and high-performance websites.
           I focus on Server-Side Development, Database Management, API Development & Integration
           Security & Authentication, Scalability & Performance Optimization, Maintenance & Support.
           `,
    img: "https://img.icons8.com/external-flaticons-flat-flat-icons/64/000000/external-backend-no-code-flaticons-flat-flat-icons.png",
  },
  {
    name: "Mobile Application Development",
    desc: `We provide a range of mobile application development services
    including custom mobile development on Android platforms, building
    cross-platform apps, designing user experience and integrating
    innovative mobile interfaces such as  chatbots and voice-controlled 
    features, to provide modern and interactive experiences.  Building
     versatile apps that perform seamlessly across both Android and iOS 
     platforms, ensuring a broad reach for your audience.`,
    img: "https://img.icons8.com/external-justicon-lineal-color-justicon/64/000000/external-app-development-responsive-web-design-justicon-lineal-color-justicon.png",
  },

];
 //experience starts
const dob = '2022-08-01';

const about = (
        <>
          I'm a Software Developer having {<b>{calculateAgeInYears(dob)} years</b>} of experience with a strong track 
          record of taking projects from concept to completion. I excel in turning wireframes
          and design concepts into high-performing software applications, ensuring a seamless
          user experience through clean, reusable, and efficient code. My passion lies in 
          blending design, technology, and innovation, guiding each project from initial 
          idea to final release. I have strong knowledge of Frontend and Backend Both.
          Currently, I am focused on backend development, driving the 
          technical foundations of my work.
        </>
        )

const resume = "";

const technologies_tools = `Using a combination of cutting-edge technologies and reliable
                          open-source software I build user-focused, performant apps and
                          websites for smartphones, tablets, laptops and desktops.`;


const projects = [
  // webs
  {
    src: a1residential,
    type:"web",
    link:"https://a1residentialbuilders.com/",
    name:"A1ResidentialBuilders",
    figma:"https://www.figma.com/design/r5BUGIFP1Kzw2tvAEI3iv1/Untitled?node-id=0-1&p=f",
    adminFigma:"https://www.figma.com/design/g5AY22eZS5zAaIIFSFlUpG/A1---Admin?node-id=0-1&p=f",
    isSecure:false,
    description:`Regardless of the size of your home, maintaining it can be a struggle.
     While you may not have the time or the tools to accomplish everything on your to-do
      list, what you do have is a local Bauer X® with a reliable team of experts who
       offer handyman services with a Done Right Guarantee.`
  },
  {
    src: prontocasecase,
    link:"https://prontocasecash.com/",
    name:"Pronto Case Cash",
    figma:"https://www.figma.com/design/nWX94AvnPPq8B6w4Y1mQtl/Law-firm-Probationary-Period?node-id=0-1&p=f",
    isSecure:false,
    type:"web",
    description:`Have you been hurt and injured in an vehicle or property incident
     like a slip and fall? Do you have a case pending but you need money now to help
      you through? We help people like you every day who cannot afford to wait
       ANOTHER year for their lawsuit to settle out. Our application process takes less 
       than 3 minutes and often we can have an answer for you the same day. If you need our help, please click the submit your 
       case button below so that we can go to work for you.`
  },
  {
    src: waa,
    link:"https://weareappointments.com/",
    name:"We are Appointments",
    figma:null,
    isSecure:false,
    description:`WeAreAppointments was created by agents for agents out of sheer necessity. After tiring efforts to meet new prospects by purchasing leads, non-exclusive appointments, webinar registrants, etc, we decided to develop the best way to get in front of consumers…by creating virtual and pre-set appointments.
    What could possibly be better than having an exclusive appointment show up on your calendar with someone who needs assistance?    
    Countless hours have gone into the development and shared knowledge that’s enabled us to bring our systems to your fingertips.    
    Wishing you the best of luck and continued success!`
  },
  {
    src: crm,
    link:"https://drive.google.com/drive/folders/1sHENXJl4yReoVktjcp1u3kxXDs2VuDIs?usp=sharing",
    name:"Employee Management",
    type:"web",
    figma:null,
    isSecure:false,
    description:`Employee management is the act of helping employees perform their best to achieve the organization’s overall mission and goals. It encompasses the entire employee journey, from hiring to termination.
    While there’s no universal formula, effective employee management requires building relationships with employees during their tenure. It also necessitates monitoring and measuring their work in relation to their professional goals.        Effective employee management often hinges on individual managers and their ability to motivate, communicate, and build trust with their reports. The best managers act as coaches for their employees, recognizing the great work they’re doing now while challenging them to improve.    
    While there are many tasks and duties that fall under employee management, almost all of them can fit into one of five categories.`
  },
  {
    src: TrendingNow,
    link:"",
    name:"Trend now",
    type:"web",
    figma:"https://www.figma.com/design/shmxWL5FKRO5GNOPPopBg6/PLAY",
    isSecure:false,
    description:`Get ready for the ultimate gaming experience, where 
    action, adventure, and entertainment collide! Whether you’re a
      casual player or a hardcore esports fan, we’ve got you covered
      with epic gameplay, pro tips, latest gaming news, and intense
      multiplayer battles. Join our community, level up your skills,
      and stay ahead in the gaming world!...
      Hit LIKE, SHARE & SUBSCRIBE for non-stop gaming content! 🔔 Stay tuned for updates! 
      🚀 #PLAY #GamingCommunity #GameOn #LevelUp
      `
  },
  {
    src: PathFinder,
    link:"https://path-finder-google-maps.netlify.app/",
    name:"Path Finder by Google maps",
    type:"web",
    figma:null,
    isSecure:false,
    description:`It able to find path from your location to destination.`
  },
  {
    src: relaxNow,
    link:"https://nwnt.ai/",
    name:"NWNT",
    type:"web",
    figma:null,
    isSecure:false,
    description:`NWNT is a one-stop solution for mental,
     emotional and behavioral health problems arising out of 
     stress and/or lifestyle issues.`
  },
  {
    src: iKidz,
    link:"https://ikidzschools.com/",
    name:"India's First Tech-Enabled Preschool",
    type:"web",
    figma:null,
    isSecure:false,
    description:`India‛s first and only preschool to incorporate 
    Augmented Reality into Preschool with our own in house developed
     app, IKidz gives learning a new meaning. This includes Fun learning 
     modules which help children learn Letters, Numbers, Shapes, No.
      Of seasons and many more. All this through a new way which no other
     playschool in India can do. All IKidz schools are equipped with 
     Augmented reality enabled Flash Cards and Tablets.`
  },
  {
    src: pisteyo,
    link:"https://teams.microsoft.com/v2/",
    name:"MicroSoft Pisteyo App",
    type:"web",
    figma:null,
    isSecure:false,
    description:`Pisteyo is an AI consulting firm specializing 
    in Microsoft Copilot adoption, offering tailored training, 
    workflow automation, and custom GPT chatbots. Their Microsoft
    Teams app (in beta) promotes positive habits and best practices
   for Copilot use, enhancing productivity and streamlining workflows.`
  },
  {
    src: monday,
    link:"https://terdia.monday.com/boards",
    name:"Monday.com Install App feature",
    type:"web",
    figma:null,
    isSecure:false,
    description:`Leveraged Monday.com's board feature 
    to organize and track project progress, facilitating 
    seamless communication and task management, resulting
   in improved team collaboration and project efficiency.`
  },
  {
    src: talktoenergy,
    link:"https://demo.talktomyenergy.ai",
    name:"Talk to Energy",
    type:"web",
    figma:"https://www.figma.com/design/CB5fTEjZvptQ81oe2GiCfh/Mohit_works_21-Apr?node-id=48-2&p=f",
    isSecure:false,
    description:`Talk to My Energy - Smart Energy Insights & AI Chatbot
    Talk to My Energy is an advanced platform that provides AI-powered 
    energy insights through an interactive chatbot. It helps users monitor
     and analyze their energy consumption with monthly graphs and reports,
     making energy management simple and efficient. The chatbot answers 
     queries, provides real-time data, and offers actionable insights to
    optimize energy usage.`
  },
  {
    src: highcourt,
    link:"https://punjabharyanahighcourtbar.in",
    name:"Punjab & Haryana Hight Court Bar Association",
    type:"web",
    isSecure:false,
    figma:null,
    description:`The Punjab & Haryana High Court Bar Association is
    a prestigious legal body representing advocates practicing at 
    the Punjab & Haryana High Court. Committed to upholding justice,
   legal ethics, and professional excellence, the association serves
    as a vital link between the judiciary and legal professionals.
    With a rich legacy of legal excellence, the association organizes
   seminars, workshops, and events to promote legal awareness and professional
    growth. Dedicated to fostering a strong legal community, it plays a crucial
     role in ensuring the smooth administration of justice in the region.`
  },
  {
    src: hcba,
    link:"https://hcba.anixinventive.com/",
    name:"Hight Court Bar Association",
    type:"web",
    figma:null,
    isSecure:true,
    description:`The Punjab & Haryana High Court Bar Association is
    a prestigious legal body representing advocates practicing at 
    the Punjab & Haryana High Court. Committed to upholding justice,
   legal ethics, and professional excellence, the association serves
    as a vital link between the judiciary and legal professionals.
    With a rich legacy of legal excellence, the association organizes
   seminars, workshops, and events to promote legal awareness and professional
    growth. Dedicated to fostering a strong legal community, it plays a crucial
     role in ensuring the smooth administration of justice in the region.`
  },
  {
    src: swing,
    link:"https://opaqueswingers.com/index",
    name:"The Ultimate Swinger Dating App",
    type:"web",
    figma:"https://drive.google.com/file/d/1XMdd30aiIAd4TT8xq0KK97TkvkQ0NKpc/view?usp=sharing",
    isSecure:true,
    description:`Step into a safe, respectful, and open-minded space 
    designed for adventurous couples and singles. Whether you're looking
     to explore new experiences, connect with like-minded people, or find
      the perfect match for your lifestyle, our app makes it easy. Discover
       genuine connections with verified users, chat securely, and join 
       local events or private groups. With smart matching, discretion 
       features, and a judgment-free community, your next exciting
     connection is just a swipe away.`
  },
  {
    src: swingAdmin,
    link:"https://admin.opaqueswingers.com/admin-login",
    name:"The Ultimate Swinger Dating App Admin",
    type:"web",
    figma:"https://drive.google.com/file/d/1XMdd30aiIAd4TT8xq0KK97TkvkQ0NKpc/view?usp=sharing",
    isSecure:true,
    description:`Step into a safe, respectful, and open-minded space 
    designed for adventurous couples and singles. Whether you're looking
     to explore new experiences, connect with like-minded people, or find
      the perfect match for your lifestyle, our app makes it easy. Discover
       genuine connections with verified users, chat securely, and join 
       local events or private groups. With smart matching, discretion 
       features, and a judgment-free community, your next exciting
     connection is just a swipe away.`
  },
  {
    src: GaAdmin,
    link:"https://ga-staging.castledigital.com.au/",
    name:"Grief Australia",
    type:"web",
    figma:null,
    isSecure:true,
    description:`Grief Australia Admin Panel is a comprehensive backend 
    management system developed to support the operations of Grief Australia,
   a leading organization offering grief and bereavement support services.
    The platform enables administrators to efficiently manage users, resources,
     programs, events, and content through a secure, user-friendly interface.
      Designed with scalability and ease of use in mind, the admin panel 
      streamlines content updates, user permissions, data tracking, and
      system configurations to ensure smooth day-to-day operations for 
      the organization.`
  },
  {
    src: WhatKeyAdmin,
    link:"https://app.whatkey.io/",
    name:"What Key",
    type:"web",
    figma:null,
    isSecure:true,
    description:`WhatKey Admin Panel is a centralized backend system for managing 
    the operations of the WhatKey key management platform. Designed for administrators, 
    this panel allows seamless control over digital key assignments, user access 
    levels, audit trails, and asset tracking. With a clean UI and robust 
    functionality, it simplifies the process of overseeing users, managing physical
     and digital keys, and monitoring usage history — ensuring secure and efficient
      key distribution for organizations.`
  },
  // apps
  {
    src: ga,
    link:"",
    name:"Grief Australia",
    type:"apps",
    figma:"https://www.figma.com/design/ZMfNWLaEfEgje0XfOsu8Zb/Grief-Australia---Mobile-app?node-id=1729-6926&p=f",
    adminFigma:"https://www.figma.com/design/ZMfNWLaEfEgje0XfOsu8Zb/Grief-Australia---Mobile-app?node-id=1047-6597&p=f",
    description:`Grief Australia is an organization that provides support, 
    education, and resources for individuals and families experiencing grief
     and loss. They offer counseling services, training programs, and research 
     initiatives to help people navigate bereavement. The organization focuses 
     on compassionate care, evidence-based approaches, and community support to
     assist those coping with the death of a loved one.`
  },
  {
    src: lovelife,
    link:"https://play.google.com/store/apps/details?id=com.sa.lovelife&pli=1",
    name:"Love Life",
    type:"apps",
    figma:"https://drive.google.com/drive/folders/1Ag8DUABP0OKnpaoQEUTtO9o6dwmDV-BK",
    description:`"Love Life" is a romantic comedy-drama anthology series 
    that premiered on HBO Max. It follows the journey of different characters
     as they navigate love, relationships, and personal growth over time. 
     Each season focuses on a new protagonist, exploring their experiences 
     with romance from first love to lasting connections. The show highlights 
     the ups and downs of modern relationships with humor and emotional depth.`
  },
  {
    src: sportsjournal,
    link:"",
    name:"Sports Journal",
    type:"apps",
    figma:"https://www.figma.com/design/MmjGbzMsZGEx09LmZjJoZI/Sport-Journal?node-id=283-463&p=f",
    adminFigma:"https://www.figma.com/design/MmjGbzMsZGEx09LmZjJoZI/Sport-Journal?node-id=0-1&p=f",
    description:`A Sports Journal is a structured record that captures the excitement,
     analysis, and personal reflections on various sporting events. It serves as a
      platform for athletes, fans, and analysts to document game highlights, player
       performances, strategies, and trends in the sports world.`
  },
  {
    src: skin_care,
    link:"",
    name:"Skin Care",
    type:"apps",
    figma:"https://www.figma.com/design/YOllk4yxV6hCJsLqBSA306/UpSkin-Project--Engineer-Preview-?node-id=13-742&p=f",
    description:`All-in-one app designed to help you achieve healthy, glowing skin effortlessly.
     Explore a curated list of skincare products tailored to your needs on the Home screen, 
     complete with ingredients, reviews, and expert recommendations. Chat with our intelligent
     AI-powered Skin Helper for personalized advice, routine suggestions, and instant answers
    to your skincare questions. Use the Barcode Scanner to quickly uncover detailed product information, 
    safety ratings, and user reviews before making a purchase. Finally, connect with like-minded 
    individuals in our Community space, where you can share experiences, get tips, and stay inspired 
    on your skincare journey.`
  },

]

const education =(
  <>
    Graduated with a <b>B.Tech in Information Technology</b> from Chandigarh Engineering College, I possess a strong foundation in software development and engineering principles, with hands-on experience in full-stack web development and cutting-edge technologies.
  </>
)

// Top / sidebar Link
const links = [
  {
    name: "Home",
    route: "/",
  },
  {
    name: "About",
    route: "about",
  },
  {
    name: "Services",
    route: "services",
  },
  {
    name: "Projects",
    route: "projects",
  },
  {
    name: "Contact",
    route: "contact",
  },
];

const figmaPass = "29159";

const Constant = {
  about,resume,
  technologies_tools,projects
  ,education,Profile_Photo,
  heroBg,cloud,cloudDark,
  shortIntro,techStack,
  contactLinks,links,figmaPass,serviceData
};
export default Constant;
